import { cx } from '@/lib/cva-config'

interface MainLayout extends React.ComponentProps<'div'> {
  header: React.ReactNode
  footer: React.ReactNode
  bgPattern?: boolean
}

export function MainLayout(props: MainLayout) {
  const { header, footer, children, className, bgPattern, ...rest } = props

  return (
    <div
      {...rest}
      className={cx(
        'flex min-h-lvh flex-col',
        bgPattern ? 'bg-cover bg-no-repeat' : 'bg-bg-main',
        className
      )}
      style={{
        backgroundImage: bgPattern ? `url(/bg-wave.svg)` : undefined,
      }}
    >
      {header}
      <main className="flex flex-1 flex-col">{children}</main>
      {footer}
    </div>
  )
}
